import { colors } from '../../Colors/colors'

export const sharableResources = {
   light: {
      common: {
         buttonBGColor: '!bg-transparent',
         closeIconBGColor: colors['gray-500'],
         defaultBGColor: 'bg-base-white',
         defaultBorderColor: 'border-gray-300',
         defaultIconFillColor: colors['primary-600'],
         defaultTextColor: 'text-gray-900',
         defaultDescriptionColor: 'text-gray-600',
         resourcesBGColor: 'bg-gray-100'
      },
      detailsHeader: {
         titleColor: 'text-gray-900'
      },
      detailsSection: {
         cardTitleColor: 'text-gray-700',
         descriptionColor: 'text-gray-600'
      },
      permissions: {
         headerTextColor: 'text-gray-700',
         headerDescriptionColor: 'text-gray-700'
      },
      header: {
         textColor: 'text-gray-900',
         borderColor: 'border-gray-300',
         headerBGColor: 'bg-base-white',
         refreshHandlerBGColor: '!bg-white'
      },
      resourceCard: {
         headerTextColor: 'text-gray-600',
         selectedCardBorderColor: 'border-primary-600',
         cardBGColor: 'bg-base-white',
         dotsMoveIconFillColor: colors['gray-500']
      }
   },
   dark: {}
}
